import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path, clone } from 'ramda';
import Input from '../Input';
import TextArea from '../TextArea';
import fields from './fields';
import style from './style';
import SuppliesLogMaterials from '../SuppliesLogMaterials';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import CheckBox from "../CheckBox";

const displayDate = (date = new Date()) => {
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hour = date.getHours().toString().padStart(2, '0');
  const minute = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  return `${year}-${month}-${day} ${hour}:${minute}:${seconds}`;
}

export default class SuppliesLog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fields: {},
    };
    this.changeField = this.changeField.bind(this);
    this.buildFields = this.buildFields.bind(this);
    this.buildFieldsV2 = this.buildFieldsV2.bind(this);
    this.getRemoveAllButtom = this.getRemoveAllButtom.bind(this);
    this.removeAllItems = this.removeAllItems.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeV2 = this.onChangeV2.bind(this);
    this.addListItem = this.addListItem.bind(this);
    this.removeItemV2 = this.removeItemV2.bind(this);
  }

  onChange(name, field, parentField) {
    this.props.onChange(name, field, parentField);
  }

  onChangeV2(name, field, parentField) {
    this.props.onChangeV2(name, field, parentField);
  }

  buildFields() {
    const listItemContainer = [];
    const forms = this.props.fields;

    if (forms && Object.keys(forms).length > 0) {
      for (let key in forms) {
        const tempItemContainer = [];
        const thisFields = clone(fields);
        let currentItem = forms[key];

        if (key != 'undefined' && forms[key] !== undefined) {
          for (let i = 0; i < 3; i++) {
            const Component = path(['system', 'component'], thisFields[i]);
            let options = [];
            // Need to set value from source
            if (thisFields[i].name == 'input') {
              thisFields[i].value = currentItem.emails;
              if (this.props.paintListAll) {
                options = this.props.paintListAll.emails;
              }
            } else if (thisFields[i].name == 'textfield') {
              thisFields[i].value = currentItem.data.paint;
              if (this.props.paintListAll) {
                options = this.props.paintListAll.paints;
              }
            } else if (thisFields[i].name == 'checkbox') {
              thisFields[i].value = currentItem.data.checked;
              if (currentItem.data.checked) {
                thisFields[i].label = 'Mail will be sent if you save this change to Work Order';
              }
            }

            if (!Component) {
              continue;
            }

            tempItemContainer.push(
              <span key={i}>
                <Component
                  disabled={this.props.disabled}
                  options={options}
                  field={thisFields[i]}
                  onChange={(name, field) => {
                    this.onChange(name, field, key);
                  }}
                />
              </span>
            );
          }
        }

        // Push to main container
        if (key != 'undefined' && forms[key] !== undefined) {
          listItemContainer.push(
            <div className="dynamic-list-item" style={style.box} key={key}>
              {!this.props.disabled && <button
                type="button"
                className={'btn btn-danger btn-outline float-right'}
                style={{
                  position: 'relative',
                  top: '-15px',
                  left: '0px',
                }}
                onClick={(e) => {
                  this.removeItem(e, key);
                }}
              >
                <i className="fa fa-remove"></i>
              </button>
              }
              <div style={{
                paddingTop: '25px',
              }}>
                {tempItemContainer}
              </div>
            </div>
          );
        }
      }
    }

    return listItemContainer;
  }

  buildFieldsV2() {
    const disabled = this.props.disabled;
    const finFieldsVisible = this.props.financialFieldsVisible;
    const finFieldsDisabled = this.props.financialFieldsDisabled || disabled;
    return this.props.fieldsV2.map((field, index) => (
      <div className="dynamic-list-item" style={style.box} key={field.id}>
        {!this.props.disabled && <button
          type="button"
          className={'btn btn-danger btn-outline float-right'}
          style={{
            position: 'relative',
            top: '-15px',
            left: '0px',
          }}
          onClick={(e) => {
            this.removeItemV2(e, field.id);
          }}
        >
          <i className="fa fa-remove"></i>
        </button>
        }
        <div style={{
          paddingTop: '25px',
        }}>
          {this.props.sendEmail && <div style={{ display: 'flex', marginBottom: '10px', alignItems: 'baseline' }}>
            <button
              type="button"
              disabled={!field.vendor || !field.materials.some((mat) => mat.name)}
              className={`btn btn-success ${this.props.sentEmail[field.frontend_suplog_id] || field.email_sent_date ? 'btn-outline' : ''}`}
              onClick={() => { this.props.sendEmail(field.frontend_suplog_id); }}
              style={{ marginRight: '10px' }}
            >
              <i className="fa fa-send"></i>
              <span style={{ paddingLeft: '3px' }}>Send Email</span>
            </button>
            Status: {this.props.sentEmail[field.frontend_suplog_id] || field.email_sent_date
              ? `Sent on ${displayDate(new Date(this.props.sentEmail[field.frontend_suplog_id] || field.email_sent_date))}`
              : 'Not sent'}
          </div>}
          <ReactSelectWrapper
            options={this.props.vendorsList.map(({ name, id }) => ({ value: id, label: name }))}
            className={'col-12'}
            autoFocus={false}
            field={{ label: 'Vendor', rules: { required: true }, name: 'vendor', value: field.vendor }}
            onChange={(name, { value }) => this.onChangeV2(value, name, field.id)}
            disabled={disabled}
          />
          <SuppliesLogMaterials
            materials={field.materials}
            vendorId={field.vendor}
            onChange={(index, name, value) => this.onChangeV2({ index, name, value }, 'materials', field.id)}
            financialFieldsVisible={finFieldsVisible}
            financialFieldsDisabled={finFieldsDisabled}
            disabled={disabled}
          />
          <TextArea
            field={{ label: 'Comments', name: 'comments', value: field.comments }}
            onChange={(name, { value }) => this.onChangeV2(value, name, field.id)}
            disabled={disabled}
          />
          <CheckBox
            field={{label: 'Include in the email', name:'include_in_the_email', value: field.include_in_the_email }}
            onChange={(name, { value }) => this.onChangeV2(value, name, field.id)}
          />
        </div>
      </div>
    ))
  }

  removeItem(e, id) {
    e.preventDefault();
    this.props.onChange(id, 'delete');
  }

  removeItemV2(e, id) {
    e.preventDefault();
    this.props.onRemoveV2(id);
  }

  changeField(name, field) {
    this.props.onChange(name, field);
  }

  removeAllItems(e) {
    e.preventDefault();
    this.props.onRemoveV2(null);
  }

  getRemoveAllButtom() {
    if (
      (this.props.fields && Object.keys(this.props.fields).length == 0)
      && (this.props.fieldsV2 && Object.keys(this.props.fieldsV2).length == 0)
    ) {
      return null;
    }
    return (
      <button
        className={'btn btn-danger btn-outline float-right'}
        style={{ marginLeft: '10px' }}
        onClick={this.removeAllItems}
        type="button"
      >
        <i className="fa fa-remove"></i>
        <span style={{ paddingLeft: '3px', top: '2px' }}>Remove All</span>
      </button>
    );
  }

  addListItem(e) {
    e.preventDefault();
    this.props.onChangeV2(null, 'add');
  }

  render() {
    return (
      <div className="card rounded mb-3">
        <div className="card-header rounded-top">
          Supplies Log
        </div>
        <div className="card-block">
          <div className="row">
            <div className="col col-sm-12 col-md-12 col-lg-12 pull-right">
              {!this.props.disabled && this.getRemoveAllButtom()}
              {!this.props.disabled &&
              <button type="button" className={'btn btn-success btn-outline float-right'} onClick={this.addListItem}>
                <i
                  className="material-icons material-icons"
                  style={{
                    top: '2px',
                    position: 'relative',
                    fontSize: '13px',
                  }}
                >add_circle</i>
                <span style={{ paddingLeft: '3px' }}>Add</span>
              </button>
              }
            </div>
            <div className="col col-lg-12">
              {this.buildFields()}
              {this.buildFieldsV2()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SuppliesLog.propTypes = {
  paintListAll: PropTypes.array,
  fields: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  financialFieldsVisible: PropTypes.bool,
  financialFieldsDisabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/common/SuppliesLog/index.js